// TOOD: Add authentication headers to all sent requests
const request = async (url, options) => {
	const headers = {"Content-Type": "application/json", ...options.headers}
	const response = await fetch(url, { ...options, headers })
	if (response.status < 300) {
		try {
			return await response.json()
		} catch (e) {
			try {
				return await response.body()
			} catch (e2) {
				return null
			}
		}
	} else throw response
}

const qs = (obj = {}) => new URLSearchParams(obj).toString()
export const get = (url, body = {}, options = {}) => request(`${url}${body ? `?${qs(body)}` : ""}`, {...options, method: "GET"})
export const post = (url, body = {}, options = {}) => request(url, {...options, body: JSON.stringify(body), method: "POST"})
export const patch = (url, body = {}, options = {}) => request(url, {...options, body: JSON.stringify(body), method: "PATCH"})
export const put = (url, body = {}, options = {}) => request(url, {...options, body: JSON.stringify(body), method: "PUT"})
export const del = (url, body = {}, options = {}) => request(url, {...options, body: JSON.stringify(body), method: "DELETE"})
// TODO: Add PATCH and DELETE handlers
